/* ============================================================
   YAOSKIN — Product Recommendations Carousel
   See sections/yaoskin-product-recommendations.liquid for markup
   and the rationale for using Shopify's native recommendations
   engine (same data source as the existing "Product recommendations"
   section) rather than building anything custom.

   Why this section fetches its own data instead of relying on Palo
   Alto's native swap-in: confirmed live that Palo Alto's theme.js
   only handles the FIRST element matching
   [data-section-type="related-products"] on the page — since this
   section is a SECOND instance (added underneath the existing
   native one, not replacing it), theme.js never touches it and it
   would sit on its `.yp-rec__placeholder` forever. So this section
   requests its own data from the exact same endpoint
   (window.theme.routes.product_recommendations_url, i.e.
   /recommendations/products) with its own section_id/product_id/
   limit, then swaps in the response itself — same underlying
   Shopify recommendations API and data, just fetched by us instead
   of by native code that isn't going to run for a second instance.
   ============================================================ */
(function () {
  function initCarousel(track) {
    if (track.__ypRecInit) return;

    var pages = track.querySelectorAll('[data-rec-page]');
    var total = pages.length;
    if (total <= 1) return; // nothing to page through

    var section = track.closest('section');
    if (!section) return;

    var prevBtn = section.querySelector('[data-rec-prev]');
    var nextBtn = section.querySelector('[data-rec-next]');
    var index = 0;

    function render() {
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        // Endless loop: past the last page of 4, wrap back to the first.
        index = (index + 1) % total;
        render();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        // Endless loop backwards too: before the first page, wrap to the last.
        index = (index - 1 + total) % total;
        render();
      });
    }

    track.__ypRecInit = true;
  }

  function scanForCarousel(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-rec-track]').forEach(initCarousel);
  }

  function loadRecommendations(section) {
    var sectionId = section.getAttribute('data-section-id');
    var productId = section.getAttribute('data-product-id');
    var limit = section.getAttribute('data-limit') || 12;
    var baseUrl = (window.theme && window.theme.routes && window.theme.routes.product_recommendations_url) || '/recommendations/products';
    var url = baseUrl + (baseUrl.indexOf('?') > -1 ? '&' : '?') +
      'section_id=' + encodeURIComponent(sectionId) +
      '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + encodeURIComponent(limit);

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        // The endpoint returns the section wrapped in its own
        // shopify-section div (plus a duplicate stylesheet/script tag
        // we don't need again) — pull out just our <section>'s content.
        var freshSection = temp.querySelector('section');
        if (freshSection) {
          section.innerHTML = freshSection.innerHTML;
          scanForCarousel(section);
        }
      })
      .catch(function () {
        // Leave the placeholder in place — nothing sensible to fall back to.
      });
  }

  // Only sections we render ourselves (unique id prefix set in the
  // liquid file) — the existing native "Product recommendations"
  // section already fetches its own data via Palo Alto's theme.js,
  // untouched by this script.
  document.querySelectorAll('[data-section-type="related-products"]').forEach(function (section) {
    if (section.id.indexOf('YaoskinRecs--') !== 0) return;
    loadRecommendations(section);
  });
})();
